// ============================================
// CONFIG/API.JS — LA UNICA fuente de la direccion del backend
// ============================================
// POR QUE EXISTE (2026-09-14, HARNESS-URL-UNICA)
// La direccion del backend estaba escrita A MANO en 38 archivos del cliente. De esos, solo 13
// consultaban `REACT_APP_API_URL`; los otros 25 llevaban la cadena pelada. Consecuencia: poner la
// variable de entorno movia un tercio del codigo y dejaba los otros dos tercios hablandole a
// PRODUCCION. Por eso, para montar el banco de pruebas de MOVIL-2, hubo que sustituir la cadena en
// el bundle YA COMPILADO — un parche manual del que dependia la regla "ningun harness apunta a
// produccion" de CLAUDE.md. Con este modulo, esa regla depende del CODIGO.
//
// ORDEN DE RESOLUCION
//   1. `REACT_APP_API_URL` del build, si viene. Manda siempre: es como se apunta un build a un
//      backend concreto (harness, QA, una rama).
//   2. Si la pagina se esta viendo desde una maquina LOCAL, el backend local de esa misma maquina.
//      Cuenta como local: localhost, 127.0.0.1, ::1, 10.0.2.2 (asi ve el emulador de Android al PC
//      anfitrion) y las redes privadas 192.168.x / 10.x / 172.16-31.x (telefono real en el wifi).
//   3. Cualquier otro caso: PRODUCCION. Este es el camino que recorre app.beepmexico.com.
//
// El punto 2 se resuelve EN EJECUCION, no al compilar, y esa es la diferencia que importa: un
// `REACT_APP_*` se hornea en el bundle y ya no se puede re-apuntar despues (por eso el harness
// tenia que reescribir el JS compilado). Resolviendo por el host desde el que se abre la pagina, UN
// MISMO build sirve para el PC, el emulador y produccion, y jamas se equivoca de destino.

// La direccion publica del BACKEND. Es el unico sitio del cliente donde puede estar escrita.
const API_PRODUCCION = 'https://tranquil-generosity-production-5a63.up.railway.app';

// ============================================
// LA DIRECCION PUBLICA DE LA APP — OTRA COSA, y con otra regla
// ============================================
// `API_BASE` (abajo) cambia segun desde donde se abra la pagina: eso es lo que permite probar en
// local. `URL_APP` NO cambia NUNCA: es la direccion que se le enseña a un TERCERO.
//
// POR QUE IMPORTA (2026-09-14): la liga de verificacion del certificado de garantia se armaba con
// `window.location.origin`. Generar ese documento desde un build local metia una liga a `localhost`
// DENTRO DEL PDF **y dentro del codigo QR**, y ese PDF se le manda al cliente. El cliente escanea
// el QR y no llega a ningun sitio; peor, nadie lo nota hasta que se queja.
//
// REGLA: toda liga que termine dentro de un documento, un QR, un correo o un mensaje que ve alguien
// de fuera se arma con `URL_APP`. `window.location.origin` vale para navegar dentro de la propia
// pestaña, y para nada mas.
const APP_PRODUCCION = 'https://app.beepmexico.com';

export const URL_APP = String(process.env.REACT_APP_URL_APP || APP_PRODUCCION).trim().replace(/\/$/, '');

// Atajo para las ligas publicas: `ligaPublica('garantia', codigo)` -> https://app.beepmexico.com/garantia/<codigo>
export function ligaPublica(...partes) {
  const cola = partes.filter(x => x != null && x !== '').map(x => String(x).replace(/^\/+|\/+$/g, '')).join('/');
  return cola ? `${URL_APP}/${cola}` : URL_APP;
}

// Puerto en el que escucha el backend cuando se levanta en la maquina de uno (src/index.js: 3000).
const PUERTO_BACKEND_LOCAL = 3000;

const RE_PRIVADA = /^(localhost|127\.0\.0\.1|::1|10\.0\.2\.2|192\.168\.\d{1,3}\.\d{1,3}|10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3})$/;

export function esHostLocal(hostname) {
  return RE_PRIVADA.test(String(hostname || '').replace(/^\[|\]$/g, ''));
}

function resolver() {
  // 1) Lo que diga el build, si dijo algo.
  const deBuild = process.env.REACT_APP_API_URL;
  if (deBuild && String(deBuild).trim()) return String(deBuild).trim().replace(/\/$/, '');

  // 2) ¿La pagina se abrio desde una maquina local? Entonces el backend es el de esa maquina.
  //    Se usa el MISMO hostname con el que llego el navegador: en el emulador de Android eso es
  //    10.0.2.2, que es como el emulador nombra al PC anfitrion; en el PC es localhost.
  if (typeof window !== 'undefined' && window.location && esHostLocal(window.location.hostname)) {
    return `${window.location.protocol}//${window.location.hostname}:${PUERTO_BACKEND_LOCAL}`;
  }

  // 3) Produccion.
  return API_PRODUCCION;
}

// Se resuelve UNA vez, al cargar el modulo: el destino no puede cambiar a media sesion.
export const API_BASE = resolver();

// ¿Estamos hablandole a produccion? Lo usan el aviso de pantalla y las pruebas.
export const ES_PRODUCCION = API_BASE === API_PRODUCCION;

export default API_BASE;
